export default __webpack_public_path__ + "static/media/flash_pay_banner.f510bd81.png";